import React, {
  Component
} from 'react';
import 'component/icons/Hamburger/styles.scss';

class Hamburger extends Component {

	render() {
		return <div className="icon-wrapper icon-wrapper-home icon-wrapper- m-nav m-nav d-flex align-items-center"
			data-testid={this.props["data-testid"]}
			onClick={() => {
				if(this.props.onClick) {
					this.props.onClick()
				}
			}}>
			<span id="hamburger-icon" className={`${this.props.active ? 'active' : 'inactive'} m-nav`}>
				<span className="line line-1 m-nav"></span>
				<span className="line line-2 m-nav"></span>
				<span className="line line-3 m-nav"></span>
			</span>
		</div>
	}
}

export default Hamburger;